import {Component, Input, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {RechnungenAnfordernComponent} from '../rechnungenAnfordern/rechnungenAnfordern.component';

@Component({
  selector: 'rechnungenWba',
  templateUrl: './rechnungenWba.component.html',
  styleUrls: ['./rechnungenWba.component.css']
})
export class RechnungenWbaComponent implements OnInit {
  @Input() public rechnungen
  @Input() public mandant
  constructor(
    private dialog: MatDialog,
  ) {
  }

  ngOnInit() {
  }

  public rechnungAnfordern(rechnungsNr: string){
    this.dialog.open(RechnungenAnfordernComponent, {
      data: {mandant: this.mandant, rechnungsNr: rechnungsNr},
    })
  }
}
